export default __webpack_public_path__ + "locales/az/DeleteSelfProfileDialog.json?hash=1905bfaee5dbcd76e0cbc0010ce7f9b4";